
export const verify = [
    { value: 'minimum', displayValue: 'Minimum' },
    { value: 'last', displayValue: 'Last' },
    { value: 'all', displayValue: 'All' },
    { value: 'custom', displayValue: 'Custom' },
];

export const type = [
    { value: 'quick', displayValue: 'Quick' },
    { value: 'full', displayValue: 'Full' },
    { value: 'smart ', displayValue: 'Smart' },
];

export const availableNumbers = [
    { value: '1', displayValue: '1' },
    { value: '2', displayValue: '2' },
    { value: '3', displayValue: '3' },
    { value: '4', displayValue: '4' },
    { value: '5', displayValue: '5' },
    { value: '6', displayValue: '6' },
    { value: '7', displayValue: '7' },
    { value: '8', displayValue: '8' },
    { value: '9', displayValue: '9' },
    { value: '10', displayValue: '10' },
];
export const passwordComplexity = [
    { value: 'securaze_basic', translate: 'basic', label: 'Basic' },
    { value: 'securaze_standard', translate: 'standard', label: 'Standard' },
    { value: 'microsoft', translate: 'microsoft', label: 'Microsoft' },
    { value: 'nist', translate: 'national_institute', label: 'National insitute of Standards and Technology' }]

export const valuesDiskHealth = [
    { value: "securaze", displayValue: "Securaze" }, 
    { value: "acronis", displayValue: "Acronis" }, 
    { value: "hdsentinel", displayValue: "Hard Disk Sentinel" }
];